import React, { useCallback, ChangeEvent } from "react";
import { Stack, Box } from "@mui/material";
import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { AquariusTextarea } from "@smartrr/shared/customerPortal/components/AquariusTextarea";
import { checkRetentionReasonUiIdx } from "../../../utils";
import { IPauseReason } from "@smartrr/shared/entities/CancellationRelationship";

interface IPauseReasonPickerProps {
  reasons: IPauseReason[];
  selectedPauseReason: IPauseReason | undefined;
  setSelectedPauseReason: (reason: IPauseReason) => void;
  userPauseReasonText: string | undefined;
  setUserPauseReasonText: (text: string) => void;
  placeholderText?: string;
}

export default function PauseReasonPickerItems({
  reasons,
  selectedPauseReason,
  setSelectedPauseReason,
  userPauseReasonText,
  setUserPauseReasonText,
  placeholderText,
}: IPauseReasonPickerProps) {
  const handleReasonTextChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      setUserPauseReasonText(e.target.value);
    },
    [setUserPauseReasonText]
  );

  return (
    <Stack
      spacing="15px"
      justifyContent="center"
      alignItems="center"
      sx={{ marginTop: "5px", width: "100%" }}
      data-testid="pause-reason-picker-items"
    >
      {reasons
        ?.filter(reason => !reason.isArchived && !!reason.text)
        .map(reason => (
          <AquariusButton
            sx={{ marginTop: "0px" }}
            key={reason.id}
            onClick={() => setSelectedPauseReason(reason)}
            selected={selectedPauseReason?.id === reason.id}
          >
            {checkRetentionReasonUiIdx("cancelView.pauseReason", reason, reasons)}
          </AquariusButton>
        ))}
      {selectedPauseReason?.hasCustomerPrompt ? (
        <Box sx={{ width: "100%" }}>
          <AquariusTextarea
            value={userPauseReasonText}
            placeholder={placeholderText}
            maxLength={200}
            onChange={handleReasonTextChange}
          />
        </Box>
      ) : null}
    </Stack>
  );
}
